import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';

@Component({
  selector: 'app-auth-callback',
  imports: [CommonModule],
  standalone: true,
  templateUrl: './auth-callback.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthCallbackComponent {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);

  public readonly error = signal('');

  public constructor() {
    const { code, state, error } = this.route.snapshot.queryParams;

    if (error) {
      this.error.set(String(error));
      return;
    }

    void this.exchange(code, state);
  }

  private async exchange(code?: string, state?: string): Promise<void> {
    try {
      if (!code || !state) {
        throw new Error('OneLogin returned no authorization code');
      }
      const returnUrl = await this.authService.handleLocalCallback(code, state);
      await this.router.navigateByUrl(returnUrl);
    } catch (error) {
      this.error.set(
        error instanceof Error ? error.message : 'Token exchange failed'
      );
    }
  }
}
